import dayjs from 'dayjs';

const statusEnum = {
    'requested': '요청',
    'processing': '처리',
    'awaiting_ai': '응답',
    'awaiting_batch': '배치 대기',
    'completed': '완료',
    'partial_failed': '일부 평가 실패',
    'failed': '실패',
    'retrying': '일부 항목 재평가 중',
    'cancelled': '취소'
};
const variantEnum = {
    'requested': 'secondary',
    'processing': 'info',
    'awaiting_ai': 'primary',
    'awaiting_batch': 'info',
    'completed': 'success',
    'partial_failed': 'warning',
    'failed': 'danger',
    'retrying': 'warning',
    'cancelled': 'warning'
    
};
const statusOptions = [
    {text: '평가 상태 선택', value: null},
];
const statusBadge = {};
Object.entries(statusEnum).forEach(([key, value]) => {
    statusOptions.push({
        text: value,
        value: key
    });
    statusBadge[key] = {
        text: value,
        label: value,
        variant: variantEnum[key]
    };
});

const columns = [
    {
        key: 'index',
        label: '번호',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'sub_code',
        label: 'Sub Code',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0','th-left'],
        tdClass: ['td-left'],
    },
    {
        key: 'label',
        label: 'Sub Label',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0','th-left'],
        tdClass: ['td-left'],
    },
    {
        key: 'status',
        label: '평가 상태',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'detail',
        label: '상세',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'vendor_code',
        label: '업체 코드',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'company_name',
        label: '업체명',
        thStyle: {
            width: '200px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['ellipsis'],
    },
    {
        key: 'project_code',
        label: '프로젝트 코드',
        thStyle: {
            width: '120px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['ellipsis'],
    },
    {
        key: 'campaign_id',
        label: '캠페인 ID',
        thStyle: {
            width: '80px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'updated_at',
        label: '상태변경 일시',
        thStyle: {
            width: '160px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'created_at',
        label: '평가요청 일시',
        thStyle: {
            width: '160px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'sub_link',
        label: '문항 바로가기',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
];

const aiAuditLoadingText = (status, i18n, reason = '') => {
    switch (status) {
    case 'requested':
        return i18n.t('AI 평가가 대기 중입니다.');
    case 'processing' || 'awaiting_ai':
        return i18n.t('AI 평가가 진행 중입니다.');
    case 'awaiting_batch':
        return i18n.t('AI 평가가 배치 처리 대기 중입니다. (최대 24시간)');
    case 'failed':
        return i18n.t('AI 평가 요청이 실패했습니다.');
    case 'partial_failed':
        return i18n.t('AI 평가 일부 항목이 실패했습니다.');
    case 'retrying':
        return i18n.t('일부 항목 재평가 중입니다.');
    case 'cancelled':
        return i18n.t('AI 평가가 취소되었습니다.');
    case 'completed':
        return null;
    default:
        return i18n.t('AI 평가 데이터가 없습니다.');
    }
};

const checkCanRequestAi = (status, requested_at) => {
    // 배치는 최대 24시간 대기가 정상이라 시간으로 풀지 않는다(백엔드 dedup 도 무조건 차단).
    if (status === 'awaiting_batch') {
        return false;
    }
    if (status === 'requested' || status === 'processing' || status === 'awaiting_ai' || status === 'retrying') {
        if(status === 'retrying' && dayjs().diff(dayjs(requested_at), 'minute') > 14) {
            return true;
        }
        return dayjs().diff(dayjs(requested_at), 'minute') > 4;
    }
    return true;
};


export {
    columns,statusBadge,statusOptions,aiAuditLoadingText, checkCanRequestAi
};
